module.exports = __webpack_public_path__ + "img/close_with_shadow.f79ad141.svg";